// Fixed-timestep simulation loop, decoupled from rendering.
// Render runs at rAF speed; simulation ticks at SIM_HZ scaled by game speed.
import { store } from './store.js';
import { bus } from './bus.js';

const SIM_HZ = 20;                 // simulation ticks per second at speed 1
const STEP = 1 / SIM_HZ;
const DAY_LENGTH_SEC = 24;         // one in-game day = 24 real seconds at speed 1

const SEASONS = ['winter', 'winter', 'spring', 'spring', 'spring', 'summer', 'summer', 'summer', 'autumn', 'autumn', 'autumn', 'winter'];

let accumulator = 0;
let lastTime = 0;
let dayTimer = 0;
let lastRenderT = 0;
let renderFns = [];
let simFns = [];

export function onRender(fn) { renderFns.push(fn); }
export function onSimTick(fn) { simFns.push(fn); }
export function getDayFraction() { return dayTimer / DAY_LENGTH_SEC; } // 0 = dawn, 0.5 = dusk

function simTick(dt) {
  const s = store.get();
  dayTimer += dt;
  if (dayTimer >= DAY_LENGTH_SEC) {
    dayTimer -= DAY_LENGTH_SEC;
    let { day, month, year } = s;
    day++;
    if (day > 30) { day = 1; month++; }
    if (month > 12) { month = 1; year++; }
    const season = SEASONS[month - 1];
    store.set({ day, month, year, season });
    bus.emit('sim:newDay', { day, month, year, season });
  }
  simFns.forEach((fn) => fn(dt));
}

function frame(time) {
  requestAnimationFrame(frame);
  const dtReal = Math.min((time - lastTime) / 1000, 0.1);
  lastTime = time;
  const speed = store.get().screen === 'game' ? store.get().speed : 0;
  if (speed > 0) {
    accumulator += dtReal * speed;
    let guard = 0;
    while (accumulator >= STEP && guard++ < 10) {
      simTick(STEP);
      accumulator -= STEP;
    }
  }
  // Frame cap: render at most fpsCap/sec (accumulator cadence). Camera MOVEMENT forces uncapped so
  // panning/zooming is always max-responsive. (True 120 needs a 120Hz+ display; on 60Hz a cap of 120 = 60.)
  const cap = (store.get().graphics && store.get().graphics.fpsCap) || 0;
  const prevT = lastRenderT;
  if (cap > 0) {
    const interval = 1000 / cap;
    if (time - lastRenderT < interval - 1) return;
    lastRenderT += interval;
    if (time - lastRenderT > interval) lastRenderT = time;
  } else {
    lastRenderT = time;
  }
  const renderDt = Math.min((time - prevT) / 1000, 0.1);
  renderFns.forEach((fn) => fn(renderDt));
}

export function startLoop() {
  lastTime = performance.now();
  lastRenderT = lastTime;
  requestAnimationFrame(frame);
}
